import Vue from 'vue'
import Router from 'vue-router'

import OnlineCourse from './views/OnlineCourse.vue'
import CourseChapterLists from './views/CourseChapterLists.vue'

import AnswerResult from './views/AnswerResult.vue'
import PersonalCenter from './views/PersonalCenter.vue'
import TestRecords from './views/TestRecords.vue'
import WrongTitle from './views/WrongTitle.vue'

import Order from './views/Order.vue'
import OrderList from './views/OrderList.vue'

import Center from './views/Center.vue'
import FinalExam from './views/FinalExam.vue'
import Home from './views/Home.vue'
import PassYearExamination from './views/PassYearExamination.vue'
import Test from './views/test.vue'
import CertificateList from './views/CertificateList.vue'
import Certificate from './views/Certificate.vue'
import CertificateTable from './views/CertificateTable.vue'
import CertificateTableNew from './views/CertificateTableNew.vue'
import MediaReacordList from './views/MediaReacordList.vue'
import Record from './views/Record.vue'

import Registration from './views/Registration.vue'

Vue.use(Router)

const routes = [
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: {
      title: '我的课程',
    },
  },
  {
    path: '/pass-year-examination',
    name: 'PassYearExamination',
    component: PassYearExamination,
    meta: {
      noTabs: true,
      title: '历年真题',
    },
  },
  {
    path: '/course-chapter-lists',
    name: 'CourseChapterLists',
    component: CourseChapterLists,
    meta: {
      noTabs: true,
      title: '章节列表',
      // keepAlive: true
    },
  },
  {
    path: '/online-course',
    name: 'OnlineCourse',
    component: OnlineCourse,
    meta: {
      noTabs: true,
      title: '在线课程',
    },
  },
  // 章节练习
  {
    path: '/module-exam',
    name: 'ModuleExam',
    component: () => import('./views/ModuleExam.vue'),
    meta: {
      noTabs: true,
      title: '章节练习',
    },
  },
  // 模拟考试
  {
    path: '/mock-exam',
    name: 'MockExam',
    component: () => import('./views/MockExam.vue'),
    meta: {
      noTabs: true,
      title: '模拟考试',
    },
  },
  // 历史记录
  {
    path: '/historical-answer',
    name: 'HistoricalAnswer',
    component: () => import('./views/HistoricalAnswer.vue'),
    meta: {
      noTabs: true,
      title: '',
    },
  },
  // 练习 答题页-题目为图片
  {
    path: '/answer-result',
    name: 'AnswerResult',
    component: AnswerResult,
    meta: {
      noTabs: true,
      title: '答题统计',
      keepAlive: true,
    },
  },
  {
    alias: '/',
    path: '/personal-center',
    name: 'PersonalCenter',
    component: PersonalCenter,
    meta: {
      title: '个人中心',
    },
  },
  {
    path: '/test-records',
    name: 'TestRecords',
    component: TestRecords,
    meta: {
      noTabs: true,
      title: '考试记录',
    },
  },
  {
    path: '/wrong-title',
    name: 'WrongTitle',
    component: WrongTitle,
    meta: {
      noTabs: true,
      title: '错题集',
    },
  },
  {
    path: '/order',
    name: 'Order',
    component: Order,
    meta: {
      noTabs: true,
      title: '在线购买',
    },
  },
  {
    path: '/order-list',
    name: 'OrderList',
    component: OrderList,
    meta: {
      noTabs: true,
      title: '订单详情',
    },
  },
  {
    path: '/center',
    name: 'Center',
    component: Center,
    meta: {
      title: '课程中心',
    },
  },
  {
    path: '/final-exam',
    name: 'FinalExam',
    component: FinalExam,
    meta: {
      noTabs: true,
      title: '结业考试',
    },
  },
  {
    path: '/test',
    name: 'Test',
    component: Test,
    meta: {
      noTabs: true,
      title: '测试页',
    },
  },
  {
    path: '/certificateList',
    name: 'CertificateList',
    component: CertificateList,
    meta: {
      noTabs: true,
      title: '证书列表',
    },
  },
  {
    path: '/certificate',
    name: 'Certificate',
    component: Certificate,
    meta: {
      noTabs: true,
      title: '电子证书',
    },
  },
  {
    path: '/certificateTable',
    name: 'CertificateTable',
    component: CertificateTable,
    meta: {
      noTabs: true,
      title: '电子证书',
    },
  },
  {
    path: '/certificateTableNew',
    name: 'certificateTableNew',
    component: CertificateTableNew,
    meta: {
      noTabs: true,
      title: '电子证书',
    },
  },
  {
    path: '/record',
    name: 'Record',
    component: Record,
    meta: {
      noTabs: true,
      title: '观看记录',
    },
  },
  {
    path: '/mediaReacordList',
    name: 'MediaReacordList',
    component: MediaReacordList,
    meta: {
      noTabs: true,
      title: '观看记录',
    },
  },
  {
    path: '/registration',
    name: 'Registration',
    component: Registration,
    meta: {
      noTabs: true,
      title: '学习报名',
    },
  },
  {
    path: '/nationalList',
    name: 'nationalList',
    component: () => import('@/views/national/list.vue'),
    meta: {
      title: '国考复训',
    },
  },
  {
    path: '/nationalCourseList',
    name: 'nationalCourseList',
    component: () => import('@/views/national/course-list.vue'),
    meta: {
      title: '课程列表',
      noTabs: true,
    },
  },
  {
    path: '/nationalExam',
    name: 'nationalExam',
    component: () => import('@/views/national/exam.vue'),
    meta: {
      title: '国考',
      noTabs: true,
    },
  },
  {
    path: '/examAnswer',
    name: 'examAnswer',
    component: () => import('@/views/national/exam-answer.vue'),
    meta: {
      title: '国考总结',
      noTabs: true,
    },
  },
  {
    path: '/historyExam',
    name: 'historyExam',
    component: () => import('@/views/national/history-exam.vue'),
    meta: {
      title: '国考记录',
      noTabs: true,
    },
  },
  {
    path: '/queryCertNo',
    name: 'queryCertNo',
    component: () => import('@/views/QueryCertNo.vue'),
    meta: {
      title: '证书查询',
      noTabs: true,
    },
  },
]

export default new Router({
  base: process.env.BASE_URL,
  routes,
})

export { routes }
